export default __webpack_public_path__ + "static/media/dovah.9d739d1c.png";